import PropertyVideoContainer from "../../../../components/property/detail/PropertyVideo";

const PropertyVideo = () => {
  return <PropertyVideoContainer />;
};

export default PropertyVideo;
